module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-brands-400.eot?4a28c895ffe3bd184490cada61bb749c";